export default __webpack_public_path__ + "static/media/thumbnail1.0d6f7b84.png";